import React from "react";
import MBox from '@mui/material/Box';

const Box = React.forwardRef(({...props}, ref) => {
  return <MBox ref={ref} sx={{ width: "100%", ...props.sx }} {...props} />
});

Box.displayName = "Box";

export default React.memo(Box);